/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2024-04-03 13:48:21
 * @LastEditors: ywj@originqc.com
 * @LastEditTime: 2024-12-13 17:22:01
 * @FilePath: \qcloud-web-pc-4.0\src\components\page-header\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import './index.scss'
import Logo from './logo'
import PageNav from './page-nav'
import WorkSpace from './work-space'

import { useEffect, useState } from 'react'
// import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { useAppDispatch } from '@/redux/hooks'
import { useLocation } from 'react-router-dom';
import { getMenuList } from '@/api'
import { setMenuList } from '@/features/main/menuListSlice'
import { useUpdateUserInfo } from '@/hooks'
import url from 'url';
import { scMemberV1Jump, sgMemberV1Jump } from '@/utils/scJump';

// import SetTelModal from '../set-tel-modal';

const PageHeader = () => {
  const dispatch = useAppDispatch();
  const getUserMessage = useUpdateUserInfo();
  const getUrls = useLocation();
  // const userInfo = useAppSelector((state) => state.user.userInfo);
  const allHiddenUrl = ['/documentShow'];
  const isHidden = allHiddenUrl.includes(getUrls.pathname);
  // 曙光平台单点登录显示界面状态使用
  const [sgState, setSgState]=useState<boolean>(false)
  const [sugonData, setSugonData] = useState<any>({});
  // const [telHasState, setTelState]=useState<boolean>(false);
  useEffect(() => {
    const urlParse = url.parse(window.location.search, true);
    // 曙光单点登录
    if (window.location.search && urlParse.query.token) {
      sgMemberV1Jump(getUserMessage, setSgState, setSugonData);
      // setSgState(true)
    }
    // 双创一期单点登录
    if (urlParse.query.sc_v1 === 'v1' && urlParse.query.sc_v1Token) {
      scMemberV1Jump(this, '', getUserMessage);
    }
    //双创二期已登录，跳转到量子云
    if (window.location.search && urlParse.query.scToken) {
      scMemberV1Jump(this, 'v2', getUserMessage);
    }
    // getUserInfo().then(res => {
    //   if (res.success) {
    //     dispatch(setUserInfo(res.obj))
    //     dispatch(setLoginStatus(true))
    //   } else {
    //     dispatch(setUserInfo({}))
    //     dispatch(setLoginStatus(false))
    //   }
    // })
    // getUserMessage()
    // 工作台不请求该接口
    if (!getUrls.pathname.includes('/computerServices')) {
      getMenuList().then(res => {
        if (res.success) {
          dispatch(setMenuList(res.obj[0].menuList))
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
 
  return (
    <div className="header-placeholder">
      <header className={`page-header ${isHidden ? 'no-fixed' : ''}`}>
        <Logo />
        <WorkSpace />
      </header>
    </div>
  )
}
export default PageHeader